import cn from 'classnames';
import { LinkFormData } from './contracts';
import { Link as ReactLink } from 'react-router';

export type LinkProps = LinkFormData & {
  className?: string;
  style?: React.CSSProperties;
};

// The `--sm` size modifier is the only one that overrides link-button.scss's base font-size
// (14px -> 12px), so it takes the --size-3xs step; every other size (m/lg/fullWidth) keeps the
// base 14px, which is what small-text provides.
function linkTypographyClass(size: LinkProps['size']): string {
  return size === 'sm' ? 'text-3xs' : 'small-text';
}

export default function Link({ className, url, openInNewTab, label, variant, size, style }: LinkProps) {
  const typographyClass = linkTypographyClass(size);
  return (
    <>
      {(url as string).startsWith('#') ? (
        <ReactLink
          style={style}
          to={url}
          className={cn(`link-button-${variant}`, `link-button-${variant}--${size}`, typographyClass, className)}
        >
          {label}
        </ReactLink>
      ) : (
        <ReactLink
          style={style}
          className={cn(`link-button-${variant}`, `link-button-${variant}--${size}`, typographyClass, className)}
          to={url}
          target={openInNewTab ? '_blank' : '_self'}
        >
          {label}
        </ReactLink>
      )}
    </>
  );
}
